import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { getAccessToken } from "../utils/axios";
import { BaseClient, type Property } from "../utils/BaseClient";

/**
 * to get property details for the given propertyId
 * @param propertyId
 * @returns property details for the given propertyId
 */
export const useProperty = (
  propertyId: string | undefined
): UseQueryResult<Property> => {
  const accessToken = getAccessToken();
  const query = useQuery({
    enabled: !!accessToken && !!propertyId,
    refetchOnWindowFocus: "always",
    queryKey: ["property", propertyId],
    queryFn: async (): Promise<Property> => {
      const client = new BaseClient(accessToken);
      const property = await client.getPropertyDetails(propertyId ?? "");

      return property;
    },
  });
  return query;
};
